import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { getPosts } from "../../actions/post";

import { getTours } from "../../actions/vrtour";

import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";
import CompanyProfilePicture from "../layout/Companies/CompanyProfilePicture";
import CompanyBackgroundPicVideo from "../layout/Companies/CompanyBackgroundPicVideo";
import CompanyBackgroundPicVideoTwo from "../layout/Companies/CompanyBackgroundPicVideoTwo";
import ReportUser from "../layout/IME/ReportUser";
import CompanyOnlineUsers from "../layout/Companies/CompanyOnlineUsers";
import JobStreamPost from "../layout/Employers/JobStreamPost";
import CompanyInformationPost from "../layout/Companies/CompanyInformationPost";
import CompanyCreatePost from "../layout/Companies/CompanyCreatePost";
import CompanyCreatePhotoPost from "../layout/Companies/CompanyCreatePhotoPost";
import CompanyCreateVideoPost from "../layout/Companies/CompanyCreateVideoPost";
import CompanyPostItem from "../layout/Companies/CompanyPostItem";
import CompanyNotifications from "../layout/Companies/CompanyNotifications";
import IMEAltLogo from "../layout/IME/IMEAltLogo";

const CompanyProfile = ({
  auth: { user, isAuthenticated },
  getPosts,
  post: { posts, loading },
  getTours,
  vrtour: { vrtours, tourloading },
  // isAuthenticated
}) => {
  const [profilePicOpen, setprofilePicOpen] = useState(false);
  const [createPostOpen, setcreatePostOpen] = useState(false);
  const [createPhotoPostOpen, setcreatePhotoPostOpen] = useState(false);
  const [createVideoPostOpen, setcreateVideoPostOpen] = useState(false);
  const [notificationsOpen, setnotificationsOpen] = useState(false);
  const [reportUserOpen, setreportUserOpen] = useState(false);
  useEffect(() => {
    getTours();
    getPosts();
  }, [getTours, getPosts]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {profilePicOpen && (
        <div className="profile-picture-overlay">
          <div className="profile-avi-container">
            <i
              className="fas fa-times fa-3x profile-x"
              onClick={(e) => setprofilePicOpen(false)}
            ></i>
            <CompanyProfilePicture />
          </div>
        </div>
      )}
      {createPostOpen && (
        <div className="create-post-overlay">
          <div className="create-post-box">
            <i
              className="fas fa-times fa-3x profile-x"
              onClick={() => setcreatePostOpen(false)}
            ></i>
            <CompanyCreatePost />
          </div>
        </div>
      )}
      {createPhotoPostOpen && (
        <div className="create-post-photo-overlay">
          <div className="create-post-media-box">
            <i
              className="fas fa-times fa-3x profile-x"
              onClick={() => setcreatePhotoPostOpen(false)}
            ></i>
            <CompanyCreatePhotoPost />
          </div>
        </div>
      )}
      {createVideoPostOpen && (
        <div className="create-post-video-overlay">
          <div className="create-post-media-box">
            <i
              className="fas fa-times fa-3x profile-x"
              onClick={() => setcreateVideoPostOpen(false)}
            ></i>
            <CompanyCreateVideoPost />
          </div>
        </div>
      )}
      {notificationsOpen && (
        <div className="notification-overlay">
          <div className="notification-box-container">
            <div
              className="notification-x"
              onClick={(e) => setnotificationsOpen(false)}
            >
              <i className="far fa-times-circle fa-3x blue"></i>
            </div>
            <CompanyNotifications />
          </div>
        </div>
      )}
      {reportUserOpen && <ReportUser />}
      <LoggedInNavBlue />
      <div className="flex-all-content-profile">
        <CompanyOnlineUsers />
        <div className="main-profile-section">
          <CompanyBackgroundPicVideo setprofilePicOpen={setprofilePicOpen} />
          <div className="company-posts-section">
            <div className="buttons-posts">
              <div className="company-profile-main">
                <div className="profile-posts">
                  <div className="mid-container-absolute">
                    <div className="avi-color-border blue">
                      <img
                        alt="avatar"
                        src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                          user && user.avatar
                        }`}
                        className="profile-avi"
                        onClick={() => setprofilePicOpen(true)}
                      />
                    </div>
                  </div>
                  <div className="grid-profile-items">
                    <p className="user-online-item">
                      <span className="blue name-font">
                        {user && user.companyname}
                      </span>
                      <span className="fa-stack mx-5">
                        <i className="fas fa-certificate fa-stack-2x blue"></i>
                        <span className="fa fa-stack-1x">
                          <span>
                            <i className="fas fa-check black"></i>
                          </span>
                        </span>
                      </span>
                    </p>
                    <p className="info-item-profile">{user && user.location}</p>
                  </div>
                  {/* {user._id === profile._id && ( */}
                  <div className="friend-buttons-container">
                    <div
                      className="action-items blue"
                      onClick={() => setcreatePostOpen(true)}
                    >
                      <div className="action-button">
                        <i className="fas fa-edit action-icon fa-lg"></i>
                      </div>
                      <p className="action-text">Post</p>
                    </div>
                    <div
                      className="action-items blue"
                      onClick={() => setcreatePhotoPostOpen(true)}
                    >
                      <div className="action-button">
                        <i className="fas fa-camera-retro action-icon fa-lg"></i>
                      </div>
                      <p className="action-text">Photo</p>
                    </div>
                    <div
                      className="action-items blue"
                      onClick={() => setcreateVideoPostOpen(true)}
                    >
                      <div className="action-button">
                        <i className="fas fa-film action-icon fa-lg"></i>
                      </div>
                      <p className="action-text">Video</p>
                    </div>
                  </div>
                  <div className="friend-buttons-container">
                    <div className="action-items blue">
                      <div className="action-button">
                        <i className="fas fa-check action-icon fa-lg"></i>
                      </div>
                      <p className="action-text">Follow</p>
                    </div>
                    <div className="action-items blue">
                      <span className="fa-stack mx-5">
                        <i className="fas fa-certificate fa-stack-2x certified-position"></i>
                        <span className="fa fa-stack-1x certified-check">
                          <span>
                            <i className="fas fa-check black"></i>
                          </span>
                        </span>
                      </span>
                      <p className="action-text">
                        Request certification for this employer
                      </p>
                    </div>
                  </div>
                  <div className="friend-buttons-container">
                    <div className="secondary-logo-container-alt">
                      <IMEAltLogo />
                    </div>
                  </div>
                  {/* )} */}
                  {/* <div className="count-items-container">
                    <ul className="profile-user-count-items">
                      <li className="profile-user-count-item">
                        <span className="blue mr-5">Telecommunications</span>
                      </li>
                      <li className="profile-user-count-item">
                        Founded{" "}
                        <span className="white mr-5">June 28, 1963</span>
                      </li>
                      <li className="profile-user-count-item">
                        <i className="fas fa-check fa-lg mr-5 blue"></i>
                        <span className="blue mr-5">Followers</span>
                        <span className="white">5,852</span>
                      </li>
                    </ul>
                    <div className="profile-ellipsis">
                      <i className="fas fa-ellipsis-h mx-5 fa-lg blue"></i>
                      <div className="modal">
                        <ul className="modal-items">
                          <li className="modal-item">
                            <i className="fas fa-flag mx-5 white"></i>
                            Report
                          </li>
                          <li className="modal-item">
                            <i className="fas fa-ban mx-5 white"></i>
                            Block
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div> */}
                  <CompanyInformationPost />
                  {posts.map((post) => (
                    <CompanyPostItem key={post._id} post={post} />
                  ))}
                  <JobStreamPost />
                </div>
              </div>
              <div className="profile-buttons right-buttons">
                <div className="round-button-container">
                  <div
                    className="relative-button-container"
                    onClick={() => setnotificationsOpen(true)}
                  >
                    <div className="round-button blue">
                      <i className="fas fa-bell button-icon-alt fa-2x"></i>
                    </div>
                    <div className="button-count">
                      <span className="fa-stack">
                        <i className="fas fa-circle fa-stack-2x size red"></i>
                        <span className="fa fa-stack-1x up">
                          <span className="white smaller">17</span>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="relative-button-container">
                    <div className="round-button blue">
                      <i className="fas fa-comment button-icon-alt fa-2x"></i>
                    </div>
                    <div className="button-count">
                      <span className="fa-stack">
                        <i className="fas fa-circle fa-stack-2x size red"></i>
                        <span className="fa fa-stack-1x up">
                          <span className="white smaller">4</span>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <CompanyBackgroundPicVideoTwo />
        </div>
        <div className="online-users-profile">
          <div className="online-title-container-alt">
            <div className="border-alt blue">
              <p className="online-title-alt blue">Companies</p>
            </div>
          </div>
          <div className="online-user blue">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <div className="online-avi"></div>
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">Company Name</span>
                  </li>
                  <li className="user-online-item">Location</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="online-user blue">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <div className="online-avi"></div>
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">Company Name</span>
                  </li>
                  <li className="user-online-item">Location</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="online-user blue">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <div className="online-avi"></div>
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">Company Name</span>
                  </li>
                  <li className="user-online-item">Location</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="online-user blue">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <div className="online-avi"></div>
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">Company Name</span>
                  </li>
                  <li className="user-online-item">Location</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="online-user blue">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <div className="online-avi"></div>
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">Company Name</span>
                  </li>
                  <li className="user-online-item">Location</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="online-user blue">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <div className="online-avi"></div>
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">Company Name</span>
                  </li>
                  <li className="user-online-item">Location</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="online-user blue">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <div className="online-avi"></div>
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">Company Name</span>
                  </li>
                  <li className="user-online-item">Location</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="online-user blue">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <div className="online-avi"></div>
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">Company Name</span>
                  </li>
                  <li className="user-online-item">Location</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="online-user blue">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <div className="online-avi"></div>
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">Company Name</span>
                  </li>
                  <li className="user-online-item">Location</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="online-user blue">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <div className="online-avi"></div>
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">Company Name</span>
                  </li>
                  <li className="user-online-item">Location</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="online-user blue">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <div className="online-avi"></div>
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">Company Name</span>
                  </li>
                  <li className="user-online-item">Location</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="online-user blue">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <div className="online-avi"></div>
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">Company Name</span>
                  </li>
                  <li className="user-online-item">Location</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="online-user blue">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <div className="online-avi"></div>
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">Company Name</span>
                  </li>
                  <li className="user-online-item">Location</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

CompanyProfile.propTypes = {
  auth: PropTypes.object.isRequired,
  vrtour: PropTypes.object.isRequired,
  getTours: PropTypes.func.isRequired,
  post: PropTypes.object.isRequired,
  getPosts: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  vrtour: state.vrtour,
  post: state.post,
});

export default connect(mapStateToProps, {
  getTours,
  getPosts,
})(CompanyProfile);
